import slugify from 'slugify'

const makeBlogArticlePath = title => `/blog/${slugify(title, {strict : true})}`

export default makeBlogArticlePath;